import { decodeHTML } from 'entities/lib/decode.js';
import parser, { domToReact } from 'html-react-parser';
import { createElement } from 'react';
// NOTE (2023-04-17): need version 1.0.13 otherwise '<' and anything following in strings gets trimmed
// in version 1.0.14 this is broken, maybe future versions will not be
import xss from 'xss';

import { bruteFilter } from '@/utils/sanitize';

// remove scripts and styles, allow links and images
// @ts-ignore
const gentleFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {
        a: ['alt', 'href', 'target'],
        b: [],
        br: [],
        font: ['size'],
        i: [],
        img: ['width', 'height', 'src', 'srcset', 'title'],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// @ts-ignore
const gentleNoBrFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {
        a: ['alt', 'href', 'target'],
        b: [],
        font: ['size'],
        i: [],
        img: ['width', 'height', 'src', 'srcset', 'title'],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// remove scripts, styles and images, allow links
// @ts-ignore
const gentleOldFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style', 'img'],
    whiteList: {
        a: ['alt', 'target'],
        b: [],
        br: [],
        font: [],
        i: [],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

const fontStyles = ['Inter', 'Jost'];

type SafelyRenderOptions = {
    fontStyle?: number;
    html: string;
    noBr?: boolean;
    old?: boolean;
    wrapper?: string;
};

export const safelyRender = ({
    fontStyle = 2,
    html,
    noBr = false,
    old = false,
    wrapper = 'div',
}: SafelyRenderOptions) => {
    if (!html) {
        return '';
    }
    const filter = noBr ? gentleNoBrFilter : old ? gentleOldFilter : gentleFilter;
    const boldFontName = fontStyles[fontStyle - 1];
    const filteredHtml = filter.process(decodeHTML(html)).trim();
    let safeHtml;
    try {
        const parseOpts = {
            replace: (node: any) => {
                if (node.name === 'b' || node.name === 'strong') {
                    return createElement(
                        'span',
                        { style: { fontFamily: boldFontName, fontWeight: 600 } },
                        domToReact(node.children, parseOpts)
                    );
                }
            },
        };
        safeHtml = wrapper === '' ? filteredHtml : `<${wrapper}>${filteredHtml}</${wrapper}>`;
        safeHtml = parser(safeHtml, parseOpts);
    } catch {
        safeHtml = bruteFilter.process(html).trim();
    }
    return safeHtml;
};
